// dependency imports
import { Link } from "react-router-dom";
import { Navigate } from 'react-router-dom';

// asset imports
import "./authPage.scss";
import googleSignInImage from "../../assets/images/auth_page/web_neutral_sq_SI.svg"
import googleSignUpImage from "../../assets/images/auth_page/web_neutral_sq_SU.svg"
import pageTextConfig from "../../assets/configs/Auth Page/textConfig";
import genieGigLogoImageWhite from "../../assets/images/auth_page/GenieGig_white_orange_G_thumb.png";
import genieGiglogoImage from '../../assets/images/branding/gg_thumbnail.png'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CircularProgress from '@mui/material/CircularProgress';
import useMediaQuery from '@mui/material/useMediaQuery';

// component imports
import ForgotPasswordComponent from "../../components/PageComponents/AuthPageComponents/ForgotPasswordWindow/ForgotPasswordComponent";
import GGModalWindow from "../../components/UtilityComponents/GGModalWindow/GGModalWindow";
import VerifyEmailAndRegisterComponent from "../../components/PageComponents/AuthPageComponents/VerifyEmailWithOtpComponent/VerifyEmailWithOtpComponent";
import HoneypotField from "../../components/CommonComponents/HoneypotField/HoneypotField";
import MobileAuthPage from "./mobile/MobileAuthPage";

// hook
import { useAuthPage } from "./useAuthPage";

const AuthPage = () => {

    const auth = useAuthPage();
    const {
        name, setName,
        setLoginEmail,
        registerEmail, setRegisterEmail,
        loginPassword, setLoginPassword,
        registerPassword, setRegisterPassword,
        confirmPassword, setConfirmPassword,
        loginErrorMessage,
        registerErrorMessage,
        showLoginPassword,
        showRegisterPassword,
        showConfirmPassword,
        toggleLoginPasswordVisibility,
        toggleRegisterPasswordVisibility,
        toggleConfirmPasswordVisibility,
        showResetPasswordModal, setShowResetPasswordModal,
        showEmailOTPVerificationModal, setShowEmailOTPVerificationModal,
        loginHoneypot, setLoginHoneypot,
        registerHoneypot, setRegisterHoneypot,
        loggedInStatus,
        handleLogin,
        validateRegistrationForm,
        handleGoogleAuth,
        passwordResetCompletion,
        handleSwitchToLogin,
        handleSwitchToRegister,
        handleMobileSwitchToLogin,
        handleMobileSwitchToRegister,
        isLoggingIn,
        isSubmittingRegistration,
    } = auth;

    // Desktop-only modals portal to <body>, so they must not mount on mobile
    // (the mobile experience renders its own in-sheet flows instead).
    const isMobile = useMediaQuery('(max-width: 750px)');

    if (loggedInStatus)
        return (<Navigate to="/" />)

    return (
        <div className="authPage">
            <div className="mobile-auth-root">
                <MobileAuthPage auth={auth} />
            </div>
            <div className="desktop-auth-content">
            {!isMobile && <>
            <GGModalWindow
                childView={<ForgotPasswordComponent passwordResetCompletion={passwordResetCompletion} />}
                open={showResetPasswordModal}
                title='Forgot your password?'
                onCloseHandler={() => setShowResetPasswordModal(false)}
                width='600px'
            />

            <GGModalWindow
                childView={<VerifyEmailAndRegisterComponent 
                                email={registerEmail}
                                name={name}
                                password={registerPassword}
                                honeypot={registerHoneypot}
                                componentDismiss={() => setShowEmailOTPVerificationModal(false)}
                            />}
                open={showEmailOTPVerificationModal}
                title='Verify your email'
                onCloseHandler={() => setShowEmailOTPVerificationModal(false)}
                width='600px'
            />
            </>}

            <div className="container" id="container">

                <div className="form-container sign-up-container">
                    <div className="logo mobile-only">
                        <img className='navbar-logo-img' src={genieGiglogoImage} alt="logo" />
                        <p className='navbar-logo-text'>GenieGig</p>
                    </div>
                    <form action="#">

                        <h1>{pageTextConfig.form.formRight.title}</h1>
                        <div className="social-container">
                            <img
                                alt="Google login"
                                src={googleSignUpImage}
                                onClick={handleGoogleAuth}
                            />
                        </div>
                        <span>{pageTextConfig.form.formRight.formText}</span>
                        <HoneypotField
                            value={registerHoneypot}
                            onChange={(event) => setRegisterHoneypot(event.target.value)}
                        />
                        <input
                            type="text"
                            placeholder="Name"
                            onChange={(event) => setName(event.target.value)}
                        />
                        <input
                            type="email"
                            placeholder="Email"
                            onChange={(event) => setRegisterEmail(event.target.value)}
                        />
                        <div className="input-password-container">
                            <input
                                type={showRegisterPassword ? 'text' : 'password'}
                                placeholder="Password"
                                onChange={(event) => setRegisterPassword(event.target.value)}
                            />
                            <div onClick={toggleRegisterPasswordVisibility} className="eye-icon">
                                {
                                    registerPassword.length === 0 ? '' :
                                        showRegisterPassword ?
                                            <VisibilityOffIcon /> : <VisibilityIcon />
                                }
                            </div>
                        </div>
                        <div className="input-password-container">
                            <input
                                type={showConfirmPassword ? 'text' : 'password'}
                                placeholder="Confirm Password"
                                onChange={(event) => setConfirmPassword(event.target.value)}
                            />
                            <div onClick={toggleConfirmPasswordVisibility} className="eye-icon">
                                {
                                    confirmPassword.length === 0 ? '' :
                                        showConfirmPassword ?
                                            <VisibilityOffIcon /> : <VisibilityIcon />
                                }
                            </div>
                        </div>
                        <div className="error-mesage"> {registerErrorMessage} </div>
                        <button disabled={isSubmittingRegistration} onClick={event => { event.preventDefault(); validateRegistrationForm() }}>
                            {isSubmittingRegistration
                                ? <CircularProgress size={16} thickness={5} sx={{ color: '#fff' }} />
                                : pageTextConfig.form.formRight.registerButtonText}
                        </button>

                        <div className="terms-privacy-notice">
                            By registering, you agree to the <Link to="/terms-of-service" className="legal-link">Terms and Conditions</Link> and the <Link to="/privacy-policy" className="legal-link">Privacy Policy</Link>
                        </div>

                        <div className='mobile-only change-page-title'>{pageTextConfig.overlay.overlayLeft.title}</div>
                        <div id="signIn" className='mobile-only change-page-btn' onClick={handleMobileSwitchToLogin}>
                            {pageTextConfig.overlay.overlayLeft.signInButtonText}
                        </div>

                    </form>
                </div>

                <div className="form-container sign-in-container">
                    <div className="logo mobile-only">
                        <img className='navbar-logo-img' src={genieGiglogoImage} alt="logo" />
                        <p className='navbar-logo-text'>GenieGig</p>
                    </div>
                    <form action="#">
                        <h1>{pageTextConfig.form.formleft.title}</h1>
                        <div className="social-container">
                            <img
                                alt="Google login"
                                src={googleSignInImage}
                                onClick={handleGoogleAuth}
                            />
                        </div>
                        <span>{pageTextConfig.form.formleft.formText}</span>

                        <HoneypotField
                            value={loginHoneypot}
                            onChange={(event) => setLoginHoneypot(event.target.value)}
                        />
                        <input
                            type="email"
                            placeholder="Email"
                            onChange={(event) => setLoginEmail(event.target.value)}
                        />
                        <div className="input-password-container">
                            <input
                                type={showLoginPassword ? 'text' : 'password'}
                                value={loginPassword}
                                placeholder="Password"
                                onChange={(event) => setLoginPassword(event.target.value)}
                            />
                            <div onClick={toggleLoginPasswordVisibility} className="eye-icon">
                                {
                                    loginPassword.length === 0 ? '' :
                                        showLoginPassword ?
                                            <VisibilityOffIcon /> : <VisibilityIcon />
                                }
                            </div>
                        </div>
                        <div className="error-mesage"> {loginErrorMessage} </div>
                        <div className="line-link" onClick={() => setShowResetPasswordModal(true)}> Forgot your password?</div>
                        <button disabled={isLoggingIn} onClick={event => { event.preventDefault(); handleLogin() }}>
                            {isLoggingIn
                                ? <CircularProgress size={16} thickness={5} sx={{ color: '#fff' }} />
                                : pageTextConfig.form.formleft.loginButtonText}
                        </button>

                        <div className="terms-privacy-notice">
                            By logging in, you agree to the <Link to="/terms-of-service" className="legal-link">Terms and Conditions</Link> and the <Link to="/privacy-policy" className="legal-link">Privacy Policy</Link>
                        </div>

                        <div className='mobile-only change-page-title'>{pageTextConfig.overlay.overlayRight.title}</div>
                        <div id="signUp" className='mobile-only change-page-btn' onClick={handleMobileSwitchToRegister}>
                            {pageTextConfig.overlay.overlayRight.signUpButtonText}
                        </div>
                    </form>
                </div>

                <div className="overlay-container">
                    <div className="overlay">
                        <div className="overlay-panel overlay-left">
                            <h1>{pageTextConfig.overlay.overlayLeft.title}</h1>
                            <p>
                                {pageTextConfig.overlay.overlayLeft.paragraphText}
                            </p>
                            <button
                                className="ghost"
                                id="signIn"
                                onClick={handleSwitchToLogin}
                            >
                                {pageTextConfig.overlay.overlayLeft.signInButtonText}
                            </button>
                        </div>
                        <div className="overlay-panel overlay-right">
                            <img src={genieGigLogoImageWhite} alt="GenieGig"></img>
                            <h1>{pageTextConfig.overlay.overlayRight.title}</h1>
                            <p>
                                {pageTextConfig.overlay.overlayRight.paragraphText}
                            </p>
                            <button
                                className="ghost"
                                id="signUp"
                                onClick={handleSwitchToRegister}
                            >
                                {pageTextConfig.overlay.overlayRight.signUpButtonText}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    );
};

export default AuthPage;
